<script lang="ts" setup>
import Checkbox from '~/components/form-elements/Checkbox.vue'
import { useSearchboosterStore } from '~/store/searchbooster'
import type { CategoryData } from '~/types/categories'

const props = defineProps<{
  categoriesData: CategoryData[]
}>()

const getCategories = ref<CategoryData[]>([])

const searchboosterStore = useSearchboosterStore()

const categories = computed({
  get: () => searchboosterStore.filter.params.categories,
  set: (x) => {
    searchboosterStore.filter.params.categories = x
  }
})

async function onCategoryChecked (event: any, category: CategoryData): Promise<void> {
  const { checked } = event.target

  if (checked) {
    searchboosterStore.addFilterByCategory(category.id, category.attributes.name)
  } else {
    searchboosterStore.deleteFilterByCategoryId(category.id)
  }

  await searchboosterStore.initSearch(true)
}

watch(
  () => props.categoriesData,
  (x) => {
    getCategories.value = x
  },
  { immediate: true }
)
</script>

<template>
  <div class="flex w-full flex-col">
    <Checkbox
      v-for="(x, index) in getCategories"
      :key="x.id"
      v-model="categories"
      class="
        mb-0 border-b-[0.5px] border-[#e2e2e2] py-3 !text-sm text-main-dark
        !no-underline transition-colors duration-300 ease-in-out last:border-none
        hover:text-main-green
        md:mb-3 md:border-none md:py-0 md:!text-base
      "
      :input-value="x.id"
      :label-text="x.attributes.name"
      :name="`${x.id}-${index}`"
      @on-checkbox-changed="(event: any) => onCategoryChecked(event, x)"
    />
  </div>
</template>
